/**
 * Auto-formats a date string as MM/DD/YYYY while the user types.
 */
/**
 * Formats a date string as MM/DD/YYYY, adding leading zeroes as needed.
 * Accepts:
 *   - `YYYY-MM-DD` / `YYYY/M/D` (basic ISO date)
 *   - `YYYY-MM-DDTHH:MM:SS...` (ISO datetime — the time portion is stripped,
 *     matching the shape returned by Salesforce-backed APIs)
 *   - `MM/DD/YYYY` / `M-D-YYYY`
 *   - Partial digit input (formatted progressively while typing)
 */

export function formatDateInput(value: string): string {
  if (!value) return '';

  const isoDateTime = value.match(/^(\d{4})-(\d{2})-(\d{2})T/);
  if (isoDateTime) {
    const [, year, month, day] = isoDateTime;
    return `${month}/${day}/${year}`;
  }

  const dashMatch = value.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})$/);
  if (dashMatch) {
    const [, year, month, day] = dashMatch;
    const mm = month.padStart(2, '0');
    const dd = day.padStart(2, '0');
    return `${mm}/${dd}/${year}`;
  }
  const slashMatch = value.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
  if (slashMatch) {
    const [, month, day, year] = slashMatch;
    const mm = month.padStart(2, '0');
    const dd = day.padStart(2, '0');
    return `${mm}/${dd}/${year}`;
  }
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');
  let mm = '';
  let dd = '';
  let yyyy = '';
  if (digits.length >= 2) {
    mm = digits.substring(0, 2);
  } else {
    mm = digits;
  }
  if (digits.length >= 4) {
    dd = digits.substring(2, 4);
  } else if (digits.length > 2) {
    dd = digits.substring(2);
  }
  if (digits.length > 4) {
    yyyy = digits.substring(4, 8);
  }

  let result = mm;
  if (digits.length > 2) result += `/${dd}`;
  if (digits.length > 4) result += `/${yyyy}`;
  return result;
}
